import { HomePageStarredEntities} from '@backstage/plugin-home';
import {Content, InfoCard, Page} from '@backstage/core-components';
import { HomePageSearchBar } from '@backstage/plugin-search';
import { Grid, makeStyles, Typography, Link as MuiLink } from "@material-ui/core";
import {Box} from "@material-ui/core";

const useStyles = makeStyles((theme) => ({
    linkCard: {
        height: '100%',
        cursor: 'pointer',
        transition: 'transform 0.2s, box-shadow 0.2s',
        '&:hover': {
            transform: 'translateY(-4px)',
            boxShadow: theme.shadows[4],
        },
    },
    descriptionCard: {
        height: '100%',
    },
}));

const links = [
    { title: 'What is the Platform?', url: '/docs/default/System/Platform', description: 'What is the objective platform' },
    { title: 'What is Backstage?', url: '/docs/default/component/platform-backstage', description: 'What is the backstage portal' },
    { title: 'Service Catalog', url: '/catalog', description: 'View all services and components' },
    { title: 'Documentation', url: '/docs', description: 'Browse services documentation' },
    { title: 'How to get Access?', url: '/catalog/default/component/techops-user-onboarding/docs', description: 'How to onboard staff or get added to teams.' },
];



const HomePageQuickLinks = () => {
    const classes = useStyles();
    return (
        <InfoCard title="Quick Links">
            <Grid container spacing={2}>
                {links.map((link) => (
                    <Grid item xs={12} sm={6} key={link.title}>
                        <InfoCard className={classes.linkCard}>
                            <MuiLink href={link.url} underline="none" color="inherit">
                                <Typography variant="subtitle1" gutterBottom>
                                    {link.title}
                                </Typography>
                                <Typography variant="body2" color="textSecondary">
                                    {link.description}
                                </Typography>
                            </MuiLink>
                        </InfoCard>
                    </Grid>
                ))}
            </Grid>
        </InfoCard>
    );
};



export const HomePage = () => {
    return (
        <Page themeId="home">
            <Content>
                <Box my={2}>
                    <Grid container justifyContent="center" spacing={6}>
                        <br/>
                        <h2>Objective Platform</h2>
                        <br/>
                    </Grid>
                </Box>
                <Box my={2}>
            <Grid container item justifyContent="center" xs={12}>
                <HomePageSearchBar placeholder="Search" />
            </Grid>
                </Box>
                <Box my={2}>
            <Grid container item xs={12}>
                <Grid item xs={12} md={6}>
                    <HomePageStarredEntities />
                </Grid>
                <Grid item xs={12} md={6}>
                    <HomePageQuickLinks />
                </Grid>
            </Grid>
                </Box>
            </Content>
        </Page>

    );
};

export default HomePage;